import React, {memo} from "react";
import {NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledTitleContainerDiv = styled.div`
  color: #000000;
  font-size: 0.875rem;
  font-weight: bold;
  margin-top: 8px;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  margin-right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const Title = ({titleControl, bindControl}) => {
    return titleControl && (
        <StyledTitleContainerDiv>
            <Control key={titleControl.key} control={titleControl} innerRef={bindControl} />
        </StyledTitleContainerDiv>
    );
}

export default memo(Title)